import { axiosPost } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import { useInvalidateQuery } from '@/hooks';
import { z } from 'zod';
import { queryKeyMap } from '../../../../_utils/query-keys';
import { PaymentNodeMetaFormSchema } from '../../../_models/payment-node-meta';

const PaymentNodesMetaMutationParamsSchema = z.object({
  nodesMeta: PaymentNodeMetaFormSchema.array(),
  projectId: z.string().uuid(),
});

export const useUpdatePaymentNodesMeta = () => {
  const { invalidate } = useInvalidateQuery();
  return useMutation({
    mutationFn: async (
      values: z.infer<typeof PaymentNodesMetaMutationParamsSchema>,
    ) => {
      const { projectId, ...payload } =
        PaymentNodesMetaMutationParamsSchema.parse(values);
      const res = await axiosPost(
        `/api/projects/${projectId}/payment-nodes-meta/`,
        payload,
      );
      await invalidate(queryKeyMap.paymentGraphData(projectId));
      return res;
    },
  });
};
